import React from 'react';
export default function PreferNotToAnswer() {
  const { getText } = Pollfish.ui;
  const preferNotToSayText = getText('postal_data.prefer_not_to_say');
  return (
    <li className="country country--unknown">
      <ul className="country-codes ignore-collapse">
        <li
          className="country-code"
          data-postal-code-id=""
          data-postal-code-country=""
          data-postal-code-place-id=""
          data-postal-code-prefer-not-to-say="true"
        >
          {preferNotToSayText}
        </li>
      </ul>
    </li>
  );
}
